var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEraserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.903,
    height: 11.29,
    viewBox: "0 0 12.903 11.29",
    fill: "#2eafbe",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eraser",
    "data-name": "Icon awesome-eraser",
    d: "M12.549,8.347a1.21,1.21,0,0,0,0-1.711L8.517,2.6a1.21,1.21,0,0,0-1.711,0L.354,9.056a1.21,1.21,0,0,0,0,1.711l2.419,2.419a1.21,1.21,0,0,0,.855.354H12.6a.3.3,0,0,0,.3-.3V12.23a.3.3,0,0,0-.3-.3H8.969l3.58-3.58ZM4.922,6.769l3.462,3.462-1.7,1.7H3.8L1.78,9.911,4.922,6.769Z",
    transform: "translate(0 -2.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserIcon);
export default __webpack_public_path__ + "static/media/eraser-icon.c25019b08c6b86f8879540aced29be6b.svg";
export { ForwardRef as ReactComponent };